import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {faStar} from '@fortawesome/free-solid-svg-icons';
import {TpVehicleSkillService} from 'app/blocks/service/api/tp-vehicle-skill.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {ITpVehicleSkill, TpVehicleSkill} from 'app/blocks/model/tp-vehicle-skill.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class TpVehicleSkillResource extends AbstractEntityResource<ITpVehicleSkill> {
    constructor(tpVehicleSkillService: TpVehicleSkillService, router: Router) {
        super(
            Resource.TP_VEHICLE_SKILLS,
            tpVehicleSkillService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.TP_VEHICLE_SKILLS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.TP_VEHICLE_SKILLS),
            (entity?) => new TpVehicleSkill(entity),
            (entity) => entity.id,
            faStar
        );
    }
}
